import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button,Col, Row} from "antd";
import * as translations from "../../../constants/translations";
import InverterList from '../inverters/list';
import LoggerList from '../loggers/list';
import {Link} from "react-router-dom";
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;


class LocationView extends Component {

    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired
            }).isRequired
        }).isRequired
    };

    state = {
        data: 'not loaded'
    };

    componentDidMount = async () => {
        await this.loadData(this.props.match.params.id);
    };

    componentWillReceiveProps = async (nextProps) => {
        if(this.props.match.params.id !== nextProps.match.params.id)
            await this.loadData(nextProps.match.params.id);
    };

    loadData = async (id) => {
        const request = await fetch(`${benchmarkApi}locations/${id}`);
        const data = await request.json();
        this.setState({data});
    };

    renderCol = (key, val) => {
        return <Row gutter={{xs: 0, md: 24}} className="dataview-row">
            <Col xs={24} md={8} className="dataview-label">{translations.location[key]}</Col>
            <Col xs={24} md={15} className="dataview-value">{val}</Col>
        </Row>;
    }

    render() {
        const {data} = this.state;
        return (
            <div>

                {data.Id ?
                    <div>
                        <h1>{data.Name}</h1>
                        {Object.keys(data).filter(key => key !== "Name").map((key) => this.renderCol(key, data[key]))}
                        <h2>Loggers</h2>
                        <LoggerList locationId={data.Id} showTitle={false} />
                        <div>
                            <Link to={`/loggers/new/${data.Id}`}>
                                <Button type={'primary'}>Logger Toevoegen</Button>
                            </Link>
                        </div>
                        <h2>Omvormers</h2>
                        <InverterList locationId={data.Id} showTitle={false} />
                    </div> : ''}
            </div>
        );
    }
}

const mapStateToProps = (state) => {return {}};

export default connect(mapStateToProps)(LocationView);



// WEBPACK FOOTER //
// ./src/components/baseinfo/locations/view.js